export enum EServicesActions {
  SET_SERVICES = 'services/setServices',
}
